import React from "react";

const HomeSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="12.217"
      height="9.5"
      viewBox="0 0 12.217 9.5"
    >
      <path
        fill="#37d1c0"
        d="M5.931 34.515l-3.91 3.22v3.476a.339.339 0 00.339.339l2.377-.006a.339.339 0 00.338-.339v-2.03a.339.339 0 01.339-.339h1.357a.339.339 0 01.339.339V41.2a.339.339 0 00.339.34l2.376.007a.339.339 0 00.339-.339v-3.475l-3.908-3.218a.259.259 0 00-.324 0zm6.176 2.185l-1.773-1.461V32.3a.254.254 0 00-.254-.254H8.892a.254.254 0 00-.254.254v1.54l-1.9-1.562a1.018 1.018 0 00-1.294 0L.077 36.7a.254.254 0 00-.034.358l.541.657a.254.254 0 00.359.035l4.988-4.109a.259.259 0 01.324 0l4.989 4.109a.254.254 0 00.358-.034l.541-.657a.254.254 0 00-.036-.359z"
        transform="translate(.015 -32.05)"
      ></path>
    </svg>
  );
};

export default HomeSVG;
